import React, { useState, useEffect } from "react";
import { ManagePartisanChartState } from "../../hooks/use-manage-partisan-chart";
import ManagePartisanChartControlButton from "./manage-partisan-chart-control-buttons";
import ManagePartisanChartGeneralData from "./manage-partisan-chart-general-data";
import ManagePartisanChartParties from "./manage-partisan-chart-parties";
import ManagePartisanChartRaces from "./manage-partisan-chart-races";

const ManagePartisanChartForm: React.FC<{
  state: ManagePartisanChartState;
}> = ({ state }) => {
  const isCandidateNames =
    state.form.getValues()?.races?.length > 0
      ? state.form
        .getValues()
        ?.races.filter((race) => race.candidateNames?.length > 0).length > 0
      : false;
  const [errors, setErrors] = useState({});
  const [candidatesNamesChecked, setCandidatesNamesChecked] =
    useState<boolean>(isCandidateNames);

  return (
    <>
      <form
        className="container w-full mx-auto"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <ManagePartisanChartGeneralData
          state={state}
          candidatesNamesChecked={candidatesNamesChecked}
          setCandidatesNamesChecked={setCandidatesNamesChecked}
        />
        <ManagePartisanChartParties state={state} />
        <ManagePartisanChartRaces
          candidatesNamesChecked={candidatesNamesChecked}
          state={state}
          handleErrors={setErrors}
          errors={errors}
        />
      </form>
      <ManagePartisanChartControlButton errors={errors} state={state} />
    </>
  );
};

export default ManagePartisanChartForm;
